/* lib/api/auth.js — боевые auth/workspace-эндпоинты (порт из frontend/src/lib/api/auth.js, 1:1).
 * Все возвращают apiFetch-контракт { ok, status, data } (НЕ бросают). */
import { QUIET_POLL, apiFetch } from './client.js';

export const register = (body) => apiFetch('/api/auth/register/', { method: 'POST', body });
export const login = (body) => apiFetch('/api/auth/login/', { method: 'POST', body });
export const logout = () => apiFetch('/api/auth/logout/', { method: 'POST' });
// req — опции запроса (сверка «кто я» соседней вкладки идёт { track: false }, см. client.js)
export const me = (req) => apiFetch('/api/auth/me/', req);

// Telegram-коннектор (входа через TG нет). Привязка — ЧЕРЕЗ БОТА: создать одноразовый
// запрос → показать ссылку t.me/<bot>?start=link_… → опрашивать статус, пока поллер
// бота не привяжет from.id входящего /start (TelegramLinkFlow). Через oauth.telegram.org
// не ходим: Telegram помнит вход в браузере и молча возвращает прежний аккаунт (S29).
export const telegramConfig = () => apiFetch('/api/auth/telegram/config/');
export const telegramLinkRequest = () =>
  apiFetch('/api/auth/telegram/link-request/', { method: 'POST', body: {} });
// опрос только на чтение: по умолчанию вне счёта запросов в полёте (QUIET_POLL) — не держит и
// не сбрасывает переход вкладки в пространство, выбранное в соседней; req — переопределить
export const telegramLinkRequestStatus = (token, req) =>
  apiFetch(`/api/auth/telegram/link-request/${encodeURIComponent(token)}/`, { ...QUIET_POLL, ...req });
// Отвязка Telegram от текущего аккаунта (идемпотентно). Для СМЕНЫ — отвязать, затем привязать новый.
export const telegramUnlink = () =>
  apiFetch('/api/auth/telegram/link/', { method: 'DELETE' });

// Пометить игровой онбординг пройденным (завершён или пропущен). Идемпотентно.
// Опц. {entities:[{kind,id}]} — реальные демо-сущности, которые бэк удалит.
// req — опции запроса: закреплённое пространство тура (pinWorkspace() при его старте)
export const completeOnboarding = ({ entities = [] } = {}, req) =>
  apiFetch('/api/auth/onboarding/complete/', { method: 'POST', body: { entities }, ...req });

// Телеметрия воронки онбординга (best-effort, fire-and-forget — не ждём ответа).
export const trackOnboarding = (body) => {
  try { apiFetch('/api/auth/onboarding/event/', { method: 'POST', body }).catch(() => {}); }
  catch { /* noop */ }
};

// Онбординг-флоу CJM демо-стенда («подключить свои данные» → мастер настройки).
// GET → {flow: object|null}; POST {demo_signup_token} → {flow} (привязка заявки со
// стенда к уже существующему аккаунту, см. SignIn); PATCH {…} → {flow} (шаги мастера).
export const getOnboardingFlow = () => apiFetch('/api/auth/onboarding/flow/');
export const createOnboardingFlow = (token) =>
  apiFetch('/api/auth/onboarding/flow/', { method: 'POST', body: { demo_signup_token: token } });
export const patchOnboardingFlow = (payload) =>
  apiFetch('/api/auth/onboarding/flow/', { method: 'PATCH', body: payload });

export const verifyEmail = (body) =>
  apiFetch('/api/auth/verify-email/', { method: 'POST', body });
export const resendVerify = (body) =>
  apiFetch('/api/auth/resend-verify/', { method: 'POST', body });

export const requestPasswordReset = (body) =>
  apiFetch('/api/auth/password/reset/', { method: 'POST', body });
export const confirmPasswordReset = (body) =>
  apiFetch('/api/auth/password/reset/confirm/', { method: 'POST', body });

export const listWorkspaces = () => apiFetch('/api/auth/workspaces/');
export const switchWorkspace = (workspaceId) =>
  apiFetch('/api/auth/workspaces/switch/', {
    method: 'POST',
    body: { workspace_id: workspaceId },
  });

// Создать бизнес-пространство. Тело: {name, restaurant?:{...}} → {workspace}.
export const createBusinessWorkspace = (body) =>
  apiFetch('/api/auth/workspaces/business/', { method: 'POST', body });

// Переименовать workspace (admin пространства).
export const renameWorkspace = (workspaceId, name) =>
  apiFetch(`/api/auth/workspaces/${workspaceId}/`, {
    method: 'PATCH',
    body: { name },
  });

// Архивировать (soft-delete) бизнес-пространство (только владелец; personal нельзя).
export const archiveWorkspace = (workspaceId) =>
  apiFetch(`/api/auth/workspaces/${workspaceId}/`, {
    method: 'PATCH',
    body: { archived: true },
  });
